<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    collapse: Boolean,
  },
  computed: {
    classes() {
      return {
        "tg-list": true,
        "tg-list--collapse": this.collapse,
      };
    },
  },
};
</script>